import React from "react";

function Project({ project }) {
  const techs = project.technologies;

  return (
    <article
      id="project"
      className="scroll-section flex justify-center items-start pt-[200px] max-sm:pt-[50px]  max-lg:flex-col max-lg:pb-6 max-lg:px-10 max-sm:px-5 max-lg:items-center max-lg:text-center max-sm:items-center"
    >
      <img
        src={project.img}
        alt="project"
        className=" h-[60vh] max-lg:h-[40vh] max-sm:h-[25vh]"
      />
      <div className="right w-full max-sm:px-10  ">
        <h3 className="text-[50px] max-md:text-[40px] max-sm:text-[30px]  mb-5 font-bold">
          {project.name}
        </h3>
        <ul className="mb-5 flex gap-3">
          {techs.map((item) => {
            return (
              <li key={item} className="font-semibold text-yellow">
                {item}
              </li>
            );
          })}
        </ul>
        <p className="mb-5 w-[70%] max-lg:w-[100%] max-lg:m-auto text-[14px] max-lg:hidden">
          {project.description}
        </p>
        <article className="btns flex max-sm:flex-col gap-3">
          <a
            href={project.live}
            target="__blank"
            className="bg-black flex justify-center items-center p-3 w-[200px] max-sm:w-[100%] text-white rounded-md"
          >
            Live Demo
          </a>
          <a
            href={project.github}
            target="__blank"
            className="border flex justify-center items-center border-black text-black p-3 w-[200px] max-sm:w-[100%] font-semibold rounded-md"
          >
            Github Repo
          </a>
        </article>
      </div>
    </article>
  );
}

export default Project;
